import { Vehicle, VehicleAdministrator } from '@/entities';
import { RowVehicleAdministratorDto, CreateVehicleAdministratorDto, UpdateVehicleAdministratorDto } from '../../../dtos/fleet-management/vehicle_administrator.dto';
import { getVehicleAdministratorRol } from '@/helpers/options';

export const formatVehicleAdministratorDto = async (rowVehicleAdministratorDto: RowVehicleAdministratorDto, idVehicle: number, isCreate: boolean) => {
    const vehicle = { id: idVehicle } as Vehicle;

    const vehicleAdministratorDto = {
        role: rowVehicleAdministratorDto.administrator_role_id.toString(),
        admin_id: rowVehicleAdministratorDto.admin_id,
        vehicle: vehicle,
        details: {
            admin_id: rowVehicleAdministratorDto.admin_id,
            administrator: rowVehicleAdministratorDto.admin_name
        }
    }

    return (isCreate) ? vehicleAdministratorDto as CreateVehicleAdministratorDto :
        vehicleAdministratorDto as UpdateVehicleAdministratorDto
}

export const formatRowVehicleAdministrator = (vehicleCompanies: VehicleAdministrator[]): RowVehicleAdministratorDto[] => {
    const vehicleAdmins = vehicleCompanies.filter(x => x.details);
    return vehicleAdmins.map((r) => {
        const row: RowVehicleAdministratorDto = {
            id: r.id,
            vehicle_id: r.vehicle.id,
            admin_id: r.admin_id,
            admin_name: r.details?.administrator,
            administrator_role_id: parseInt(r.role),
            administrators_companies_roles_id: 0,
            role_name: getVehicleAdministratorRol(parseInt(r.role)).label,
            is_active: r.is_active,
            is_updated: false
        }
        return row;
    });
}
